import { TypedDocumentNode, gql } from '@apollo/client';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { Currency } from '@sorare/core/src/__generated__/globalTypes';
import { AccountEntry } from '@sorare/core/src/components/mySorare/TransactionsHistory/UserAccountEntries/AccountEntry';
import { glossary } from '@sorare/core/src/lib/glossary';

import { DumbSo5Reward_userAccountEntry } from './__generated__/index.graphql';

type Props = {
  userAccountEntry: DumbSo5Reward_userAccountEntry;
  primaryCurrency: Currency;
  children?: ReactNode;
};

export const DumbSo5Reward: FC<PropsWithChildren<Props>> = ({
  userAccountEntry,
  primaryCurrency,
  children,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <AccountEntry
      userAccountEntry={userAccountEntry}
      title={formatMessage(glossary.reward)}
      primaryCurrency={primaryCurrency}
    >
      {children}
    </AccountEntry>
  );
};

DumbSo5Reward.fragments = {
  userAccountEntry: gql`
    fragment DumbSo5Reward_userAccountEntry on UserAccountEntry {
      id
      ...AccountEntry_userAccountEntry
    }
    ${AccountEntry.fragments.userAccountEntry}
  ` as TypedDocumentNode<DumbSo5Reward_userAccountEntry>,
};
